import React, { useRef, useContext, useEffect } from "react"
import styled from "styled-components"
import ContentWrapper from "styles/contentWrapper"
import { MDXRenderer } from "gatsby-plugin-mdx"
import labelImg from "content/images/label.svg"

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.white};
  padding: 3rem 0;
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: block;
    .title {
      padding: 0;
    }
    .inner {
      border-radius: 1.5rem;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      border: .1rem solid rgba(48, 191, 217, .2);
      width: 100%;
      height: 18rem;
      padding: 2rem;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 100%;
        height: 26rem;
        padding: 4rem;
      }
    }
  }
`

const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 3rem;
  .calendar {
    padding: 1rem;
    width: 34rem;
    display: flex;
    justify-content: center;
    border-radius: 16px;
    box-shadow: 0 1rem 2.5rem rgb(132 156 156 / 15%);
  }
  .content {
    flex: 1 1 100%;
    max-width: 40rem;
    padding-right: 0;
    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      margin-top: 1rem;
      margin-bottom: 2rem;
      li {
        padding: 1rem 0;
        &:first-of-type {
          background: radial-gradient(274.5px at 50% 49.55%, #f3f8f9 0, rgba(243, 248, 249, .76) 24.8%, rgba(243, 248, 249, 0) 100%);
        }
        display: flex;
        .label {
          background-image: url(${labelImg});
          min-width: 4rem;
          height: 1.8rem;
          background-size: 2.8rem 1.8rem;
          background-repeat: no-repeat;
          background-position: center;
          line-height: 1.5rem;
          font-weight: 600;
          font-size: 1.1rem;
          letter-spacing: -.05rem;
          color: #fff;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          padding-right: .3rem;
        }
      }
    }
  }

  @media (min-width: 900px) {
    justify-content: space-between;
    .content {
      flex: 1 1 40%;
      padding-right: 3rem;
      .calendar {
        padding: 2rem;
      }
    }
  }
`

const StyledVideo = styled.div`
  margin-top: 3rem;
  .iframe-wrapper-small, .iframe-wrapper-large {
    margin-bottom: 2rem;
  }
  .iframe-wrapper-small {
    display: none;
  }
  .iframe-wrapper-large {
    display: block;
    width: 100%;
    max-width: 60rem;
    margin: auto;
    iframe {
      border-radius: 6px;
      box-shadow: 0 1rem 2.5rem rgba(132, 156, 156, 0.15);
      background-color: white;  
    }
  }
  @media (max-width: 1200px) {
    flex: 1 1 100%;
  }
  @media (max-width: 600px) {
    .iframe-wrapper-small {
      display: block;
    }
    .iframe-wrapper-large {
      display: none;
    }
  }
`



const Booking = ({content}) => {
  const { frontmatter, body } = content[0].node

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  }, [])
  return (
    <StyledSection id="booking">
      <StyledContentWrapper>
        <h2 className="section-title">{frontmatter.title}</h2>
        <StyledFlex>
          <div className="content">
            <MDXRenderer>{body}</MDXRenderer>
            <StyledVideo>
              <div className="iframe-wrapper-large">
                <iframe width="100%" height="350" src="//www.youtube.com/embed/FbdbN4Edu44" frameBorder="0" allowFullScreen></iframe>
              </div>
              <div className="iframe-wrapper-small">
                <iframe width="100%" height="157.5" src="//www.youtube.com/embed/FbdbN4Edu44" frameBorder="0" allowFullScreen></iframe>
              </div>
            </StyledVideo>
          </div>
          <div className="calendar">
            <div className="calendly-inline-widget" data-url="https://calendly.com/hrflowai/website?hide_event_type_details=1&hide_gdpr_banner=1" style={{ minWidth: '320px', height: '766px', overflow: "hidden"}}></div>
          </div>
        </StyledFlex>
      </StyledContentWrapper>
    </StyledSection>
  )
}

export default Booking
